import isDefaultStringRecordExport from '../is/is-default-string-record-export.js';
import isStringRecord from '../is/is-string-record.js';
const DEFAULT_LOADED_TRANSLATIONS_RECORD = Object.freeze({});
export default function mapTranslationsRecordToLoadedTranslationsRecord(translationsRecord) {
    let loadedTranslationsRecord = DEFAULT_LOADED_TRANSLATIONS_RECORD;
    const entries = Object.entries(translationsRecord);
    for (const [locale, translations] of entries) {
        if (isDefaultStringRecordExport(translations)) {
            loadedTranslationsRecord = {
                ...loadedTranslationsRecord,
                [locale]: translations.default,
            };
        }
        if (isStringRecord(translations)) {
            loadedTranslationsRecord = {
                ...loadedTranslationsRecord,
                [locale]: translations,
            };
        }
    }
    return loadedTranslationsRecord;
}
//# sourceMappingURL=map-translations-record-to-loaded-translations-record.js.map